module.exports = __webpack_public_path__ + "static/fx_5.b1ccc686.jpg";